import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import { ref } from "vue";
import { usePanels } from "@/composables/usePanels";
import { useAuth } from "@/composables/useAuth";
import PanelSettingsEditor from "./PanelSettingsEditor.vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "AddPanelModal",
},
  __name: 'AddPanelModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emit = __emit;
const { createPanel } = usePanels();
const { user } = useAuth();

const showSettingsEditor = ref(true);
const settings = ref({
  title: "",
  instructions: "",
  agentType: "",
  schedule: "",
});
const isCreating = ref(false);
const errorMessage = ref("");

function handleSettingsUpdate(newSettings: {
  title: string;
  instructions: string;
  agentType?: string;
  schedule?: string | { enabled?: boolean; humanText?: string; timezone?: string; cron?: string };
}) {
  if (!user.value?.homeAccountId) {
    errorMessage.value = "Missing user information.";
    return;
  }
  isCreating.value = true;
  errorMessage.value = "";
  // Map schedule (string or object) to schedule object matching Panel interface
  let schedule: { enabled: boolean; humanText: string; timezone: string; cron: string } | undefined = undefined;
  const schedInput = newSettings.schedule;
  if (typeof schedInput === "string") {
    if (schedInput.trim()) {
      schedule = {
        enabled: true,
        humanText: schedInput.trim(),
        timezone: "UTC",
        cron: ""
      };
    }
  } else if (schedInput && typeof schedInput === "object") {
    // If editor passed an object, prefer its fields
    const humanText = (schedInput.humanText || "").toString();
    if (humanText.trim()) {
      schedule = {
        enabled: !!schedInput.enabled,
        humanText: humanText.trim(),
        timezone: schedInput.timezone || "UTC",
        cron: schedInput.cron || ""
      };
    }
  }
  createPanel({
    title: newSettings.title,
    instructions: newSettings.instructions,
    agentType: newSettings.agentType,
    schedule,
  })
    .then(() => {
      emit("close");
    })
    .catch((error: unknown) => {
      if (error instanceof Error) {
        errorMessage.value = `Failed to create panel: ${error.message}`;
      } else {
        errorMessage.value = "Failed to create panel: An unknown error occurred";
      }
    })
    .finally(() => {
      isCreating.value = false;
    });
}
function handleCancel() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _withModifiers(handleCancel, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Add New Panel", -1)),
      _createVNode(PanelSettingsEditor, {
        visible: showSettingsEditor.value,
        initialSettings: settings.value,
        onUpdate: handleSettingsUpdate,
        onCancel: handleCancel
      }, null, 8, ["visible", "initialSettings"]),
      (isCreating.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Creating panel..."))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: handleCancel,
        class: "close-button"
      }, "×")
    ])
  ]))
}
}

})